import React from "react";
import Header from "../Header";
import { Grid } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import Footer from "../Footer";

type Props = {
  children: React.ReactNode,
}

const Layout : React.FC<Props> = ({ children }) => {

  const location = useLocation();

  let showLinks = !(location.pathname === "/");

  return (
      <Grid container direction="column" style={{ minHeight: '100vh' }}>
          <Grid item>
              <Header showLinks={showLinks} />
          </Grid>

          <Grid item style={{ flexGrow: 1 }}>
              <section>{children}</section>
          </Grid>

          <Grid item>
              <Footer />
          </Grid>
      </Grid>

  );

};

export default Layout;
